import { Button } from '@/components/ui/button'
import { getLocale, matchSupportedLanguage } from '@/hooks/helpers/getLocale'
import { useAuth } from '@/lib'
import { cn } from '@/lib/utils'
import { LANGUAGE_LABELS, SUPPORTED_LANGUAGES } from '@/locales'
import { useTranslation } from 'react-i18next'
import { ScreenHeading } from './screen-heading'

const OPTIONS = SUPPORTED_LANGUAGES.map(lang => ({ value: lang, label: LANGUAGE_LABELS[lang] }))

type Props = {
	onSubmit: (value: string) => void
	isSubmitting: boolean
}

export function LanguageScreen({ onSubmit, isSubmitting }: Props) {
	const { t } = useTranslation()
	const { user } = useAuth()

	const initial = user?.language ?? matchSupportedLanguage(getLocale()) ?? null

	return (
		<>
			<img src="/onboarding/language.png" alt="" className="mx-auto max-h-40 w-auto" />
			<ScreenHeading title={t('onboarding.language.title')} subtitle={t('onboarding.language.subtitle')} />
			<div className="grid grid-cols-2 gap-3">
				{OPTIONS.map(option => (
					<Button
						key={option.value}
						variant={initial === option.value ? 'default' : 'outline'}
						disabled={isSubmitting}
						onClick={() => onSubmit(option.value)}
						className={cn(
							'h-14',
							initial === option.value && 'bg-brand-600 hover:bg-brand-700 text-white border-brand-600',
						)}
					>
						{option.label}
					</Button>
				))}
			</div>
		</>
	)
}
